import GeneralView from '~/generalView';
import Handlebars from 'handlebars';

import EventHub from '~/eventHub';
import supportTickets_template from '~/templates/supportTickets.handlebars';
import toastr from 'toastr';

/**
 * Category View (show category title and a report ranking of a report)
 * @constructor
 * @type {*}
 */
var supportTicketsView = GeneralView.View.extend({
    tagName: "div",
    className: 'SupportTickets',
	ID: null,
	
    initialize: function () {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},
	
	events: {
		'click .showmore' : 'showSupportTicketInfo',
	},
	
	render: function () {
		var handlebarsTemplate = Handlebars.template(supportTickets_template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('.table-responsive').hide();
		this.translate();
		this.attachEvents();
		return this;
	},
	
	attachEvents: function() {
		var that = this;
		Parse.Cloud.run("GetTickets", { 'userID': Parse.User.current().id }).then((data) => {
			var res = {
				models: data,
			};
			var options = {
				year: 'numeric',
				month: 'short',
				day: 'numeric'
			};
			var langdate = lang + "-GB";
			for (var i = 0; i < res.models.length; i++) {
				res.models[i].creationdate = res.models[i].attributes.createdAt.toLocaleDateString(langdate, options);
			}
			var handlebarsTemplate = Handlebars.template(supportTickets_template);
			that.$el.html(handlebarsTemplate(res));
			that.translate();
			$('.supportTicketsloader').hide();
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'], 'Error');
				break;
			}
		});
	},
});
/**
 *
 * Module profileView
 * @module views/profileView
 * @returns ParseService
 */
export default supportTicketsView;
